
import { useTranslation } from "react-i18next";

import useToast from "hooks/useToast";
import "./Permissions.scss";
import {
    getUserDetail,
} from "services/user/user.session.service";
import { PPermissions } from "libs/raas-ui-react-components/src/components";
import { getChecksLiterals, getPermissionsLiterals } from "./Permissions.literals";
import { useState } from "react";
import { putAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { useNavigate } from "react-router-dom";

export const Permissions = () => {
    let privacyOptions = getUserDetail()['privacy-options'];
    let raasUserDetail = getUserDetail();
  const navigate = useNavigate();
    const { openToast } = useToast();
    const [t] = useTranslation("privateHome");
    const [t2] = useTranslation("registerflow");

    const titlesLiterals = getPermissionsLiterals(t);
    const checksLiterals = getChecksLiterals(t2, privacyOptions);
    const [checksStatus, setChecksStatus] = useState({
    
            "comercial-communications": false ,
            "personal-data-sharing": false ,
            "profile-custom-experience":  false 
        
    });


    /**
     * @description Guarda los valores de los checks en todo momento.
     * @param {CustomEvent} e Evento   
     */
    const checkChangedHandler = (e: CustomEvent) => {
        setChecksStatus(e.detail);
        const body = {
      
            customerFullName:raasUserDetail.customerFullName,
            identificationDocument:raasUserDetail.identificationDocument,
            mailingAddress:raasUserDetail.mailingAddress,
            birthDate:raasUserDetail.birthDate,
            //profileImage:"",
            ['privacy-options']: e.detail
        }
        putAxios(apiNames.PROFMANAG, true, "/customers/profiles", body)
            .then((response: any) => {
                if (response?.data) {
                    navigate('/my-profile')
                }
            })
            .catch(((err: any) => {

                openToast("error", t("literals.error"), t("literals.errorTryAgainLater"))

            }
            ))
    }



    return (
        <>
            <PPermissions
                onCheckChanged={checkChangedHandler}
                literals={titlesLiterals}
                permissions={checksLiterals}
            />


        </>
    );
};
